<div class="d-flex voters" *ngIf="viewMode == 'inline'">
  <div class="voter" *ngFor="let voter of inlineVoters; let idx=index"
    [ngStyle]="{'z-index': idx+1, 'left': (-1*(idx*8))+'px'}">
    <mtm-user-profile-picture [user]="voter" [username]="voter.username" [width]="avatarSize" [height]="avatarSize"
      forceLoadProfile="true" />


  </div>
  <div class="d-flex align-items-center justify-content-center others" *ngIf="totalOthers > 0" [ngStyle]="{'width': avatarSize + 'px','height': avatarSize + 'px', 'z-index': inlineVoters.length + 1,
       'left':  (-1*(inlineVoters.length*8))+'px'}">
    {{ totalOthers }}
  </div>
</div>


<div class="asset-voters-tooltip-container" *ngIf="viewMode == 'tooltip'">
  <div class="d-flex flex-column align-items-start tooltip-voters">
    <div *ngFor="let voter of voters" class="d-flex voter">
      <mtm-user-profile-picture [user]="voter" [username]="voter.username" [width]="avatarSize" [height]="avatarSize"
        forceLoadProfile="true" />
      <div class="d-flex flex-column align-items-start">
        <div class="name">{{ voter.fullName }}</div>
        <div class="date">{{ voter.votedAt | mtmDate }}</div>
      </div>
    </div>
  </div>
</div>